import SmruLeadForm from "./SmruLeadForm";
import { usePartnerTab } from "./usePartnerTab";

export default function SmruBrochurePage() {
    usePartnerTab("Download Brochure — AI.Prof");

    return (
        <SmruLeadForm
            variant="brochure"
            eyebrow="Free Brochure"
            title="Download the AI.Prof Brochure Start Your Career"
            submitLabel="Get the Brochure"
            brochureUrl="/general/ai.prof_brochure.pdf"
        />
    );
}
